import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';

import { MainService } from 'app/resources/services/index';
import { CartaoDestinoPipe, ContaBancariaPipe } from 'app/resources/pipes/index';

@Component({
  selector: 'app-transferencia',
  templateUrl: './transferencia.component.html'
})

export class TransferenciaComponent implements OnInit {

  public processando: boolean;
  public transferencias: any = undefined;
  public transferencia: any = { conta: { poupanca: false } };
  public documentoTipo: string;
  public transferenciaSelecionada: any = undefined;
  public router: Router;
  public location: LocationStrategy;
  public contaBancaria: ContaBancariaPipe = new ContaBancariaPipe();
  public cartaoDestino: CartaoDestinoPipe = new CartaoDestinoPipe();

  constructor(public mainService: MainService, router: Router, location: LocationStrategy) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.processando = false;
    this.documentoTipo = 'CPF';
    this.mainService.http.pathV2().get('auth/users/transferencias', true)
      .subscribe(
      sucesso => this.transferencias = sucesso.json().transferencias,
      error => { }
      );
    this.mainService.saldoService.initialize();

    if (this.mainService.permissionService.hasPermission('funcionalidade:ted')) {
      this.mainService.http.pathRest().get('cartao/transferencia/bancaria/contas/validas/', true, 'Accept')
        .subscribe(
        sucesso => { this.mainService.servicesService.contas = sucesso.json(); }
        );
    }

  }

  public verTransferencia(t) {
    this.transferenciaSelecionada = t;
  };

  public getTransacaoOrigem(transferencia) {
    if (transferencia !== undefined && transferencia.origem !== undefined) {
      if (transferencia.origem === 'transferencia_bancaria') {
        return 'Bancária';
      } else if (transferencia.origem === 'transferencia_cartao') {
        return 'Entre Cartões';
      } else if (transferencia.origem === 'transferencia_bandeirado') {
        return transferencia.cartao.produto.bandeira;
      }
    } else {
      return '';
    }
  };

  public getTransacaoOrigemModal() {
    return this.getTransacaoOrigem(this.transferenciaSelecionada);
  };

  public getTransferenciaDestino(transferencia) {
    if (transferencia !== undefined && transferencia.origem !== undefined) {
      if (transferencia.origem === 'transferencia_bancaria') {
        return this.contaBancaria.transform(transferencia.conta);
      } else if (transferencia.origem === 'transferencia_cartao' || transferencia.origem === 'transferencia_bandeirado') {
        return this.cartaoDestino.transform(transferencia.cartao);
      }
    } else {
      return '';
    }
  };

  public getTransferenciaDestinoModal() {
    return this.getTransferenciaDestino(this.transferenciaSelecionada);
  }
}



// WEBPACK FOOTER //
// ./src/app/transferencia/transferencia.component.ts